var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChecked = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "#2C364F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6169 16.5057L16.8642 8.81921C17.107 8.46334 17.0154 7.97815 16.6597 7.73518L16.0154 7.29549C15.6597 7.05269 15.1742 7.14415 14.9314 7.50006L10.5914 13.8573L8.68619 12.4979C8.33559 12.2478 7.84846 12.3291 7.59825 12.6799L7.14508 13.3148C6.8949 13.6654 6.97639 14.1526 7.32703 14.4028L10.5422 16.6968C10.8929 16.947 11.3741 16.8614 11.6169 16.5057Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(7 7)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChecked, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/checked.334eb5e9.svg";
export { ForwardRef as ReactComponent };